module.exports = __webpack_public_path__ + "img/social-2.286baa7e.jpg";